<template>
  <div class="player-block">
    <radar-card
      :player="source.player"
      :title="source.title"
      :org="org"
    />

    <div class="player-reports">
      <div
        v-for="rep in reports"
        :key="rep.file"
        class="report-card"
      >
        <div class="report-hdr">
          {{ rep.title }}
        </div>
        <button
          class="report-open-btn"
          type="button"
          @click="openReport(rep)"
        >
          Open report <span aria-hidden="true">↗</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import RadarCard from './RadarCard.vue'
import { getPlayerReports, docUrl } from '../api'

export default {
  components: { RadarCard },

  props: {
    source: {
      type: Object,
      required: true
    },
    // The active chat's data/knowledge org — see SourcesPanel.vue's `org` prop.
    org: {
      type: String,
      default: null
    }
  },

  data () {
    return {
      reports: []
    }
  },

  async mounted () {
    try {
      const { data } = await getPlayerReports(this.source.player, this.org)
      this.reports = data.reports || []
    } catch (err) {
      console.error('Player reports failed', err)
    }
  },

  methods: {
    openReport (rep) {
      window.open(docUrl(rep.file), '_blank', 'noopener')
    }
  }
}
</script>
